import { Flex, Progress, Skeleton, Text, useColorModeValue } from "@chakra-ui/react";
import { ForfaitUsage, warningColor } from "hooks/useForfaitUsage";
import Moment from "react-moment";
import { numberToHour } from "utils";

// Seuls les forfaits actifs sont colorés : un ancien forfait épuisé n'est pas une alerte
export function remainingColor(statut: boolean, remaining: number) {
  return statut ? warningColor(remaining) : null;
}

// Date de la dernière intervention d'un forfait ; rien pendant la lecture
export function LastIntervention(props: { usage: ForfaitUsage | null }) {
  const { usage } = props;
  if (!usage) {
    return null;
  }
  return usage.lastIntervention ? (
    <Moment format="DD/MM/YYYY">{usage.lastIntervention}</Moment>
  ) : (
    <>—</>
  );
}

// Temps restant sur le temps acheté, avec une barre qui se vide. Un forfait annuel n'a pas de budget d'heures
export default function ForfaitRemaining(props: {
  forfait: { statut: boolean; temps: number; type: number };
  usage: ForfaitUsage | null;
}) {
  const { forfait, usage } = props;
  const shade = useColorModeValue("600", "300");

  if (forfait.type === 2) {
    return <Text fontSize="sm">Annuel</Text>;
  }
  if (forfait.type !== 1) {
    return null;
  }
  if (!usage) {
    return <Skeleton h="8px" w="100%" borderRadius="full" />;
  }

  const remaining = forfait.temps - usage.consumed;
  const color = remainingColor(forfait.statut, remaining);
  const percent = forfait.temps > 0 ? (remaining / forfait.temps) * 100 : 0;
  return (
    <Flex align="center" gap="10px">
      <Text
        w="102px"
        flexShrink={0}
        fontSize="sm"
        whiteSpace="nowrap"
        sx={{ fontVariantNumeric: "tabular-nums" }}
      >
        <Text as="span" fontWeight="700" color={color ? `${color}.${shade}` : undefined}>
          {numberToHour(remaining)}
        </Text>
        {" / "}
        {numberToHour(forfait.temps)}
      </Text>
      <Progress
        flex="1"
        maxW="200px"
        size="xs"
        borderRadius="full"
        colorScheme={color ?? "gray"}
        value={Math.max(percent, 0)}
        aria-label="Temps restant"
      />
    </Flex>
  );
}
